webpackJsonp([114276838955818,60335399758886],{

/***/ 128:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(285);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(128);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/resume.354a5e25.pdf";

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/siwei.f08ccb08.png";

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Footer.prototype.formatDate = function formatDate(date) {
	    var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	    var day = date.getDate();
	    var monthIndex = date.getMonth();
	    var year = date.getFullYear();
	
	    return day + ' ' + monthNames[monthIndex] + ' ' + year;
	  };
	
	  Footer.prototype.render = function render() {
	    var x = new Date();
	    if (typeof window !== 'undefined') {
	      x = new Date(document.lastModified);
	    }
	    return _react2.default.createElement(
	      'div',
	      { id: 'footer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'copyright' },
	          _react2.default.createElement(
	            'li',
	            null,
	            '\xA9 Siwei Fu'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Last update: ',
	            this.formatDate(x)
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Footer = __webpack_require__(279);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _siwei = __webpack_require__(567);
	
	var _siwei2 = _interopRequireDefault(_siwei);
	
	var _resume = __webpack_require__(398);
	
	var _resume2 = _interopRequireDefault(_resume);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      'header',
	      { id: 'header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner headerContent' },
	        _react2.default.createElement(
	          'a',
	          { href: '#', className: 'image avatar' },
	          _react2.default.createElement('img', { src: _siwei2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Siwei Fu (\u5085\u56DB\u7EF4)'
	          )
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'A research scientist at ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'a',
	              { href: 'https://en.zhejianglab.com/' },
	              'Zhejiang Lab'
	            )
	          ),
	          _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'navItems' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'items' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '#one', className: 'icon fa fa-user' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Bio'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '#two', className: 'icon fa fa-edit' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Publications'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '#four', className: 'icon fa fa-envelope-o' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Contact'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: _resume2.default, className: 'icon fa fa-download' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Resume'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(122);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(433);
	
	__webpack_require__(434);
	
	var _Header = __webpack_require__(281);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Header2.default, null),
	      children()
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _react2.default.PropTypes.func
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-c8eda805379470dd4942.js